import styles from './SubmitButton.scss';

import cx from 'classnames';
import React from 'react';

interface ISubmitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const SubmitButton: React.FunctionComponent<ISubmitButtonProps> = ({ children, className, ...props }) => (
  <button
    type={'submit'}
    className={cx(styles.submitButton, className, {
      [styles.submitButtonDisabled]: props.disabled,
    })}
    {...props}
  >
    {children}
  </button>
);
